import { Navigate, useLocation } from "react-router-dom";
import { cloneElement, isValidElement } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireIntake = false }) {
  const { user, activeOrg, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (requireIntake && activeOrg && !activeOrg.intake_completed) {
    return <Navigate to="/intake" replace />;
  }
  // M124-e Fix#2: force full unmount+remount of the page tree bij org-
  // wissel. Alle lokale form-state (intake %, business_brain, wallet,
  // etc.) wordt gereset; in-flight fetches worden via unmount-cleanup
  // effectief afgebroken. Voorkomt cross-org data-lek in formulieren.
  const orgKey = activeOrg?.id || "no-org";
  if (isValidElement(children)) {
    return cloneElement(children, { key: orgKey });
  }
  return <div key={orgKey}>{children}</div>;
}

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-canvas">
      <div className="flex items-center gap-3 text-text-muted">
        <div className="w-2 h-2 rounded-full bg-accent-teal animate-pulse" />
        <span className="text-xs tracking-wider">Laden…</span>
      </div>
    </div>
  );
}
